import {
  getApiV1ThreeLetterCodePartnerAdminsClientsClientId,
  getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** クライアントID（数値）*/
  clientId: number;
};

type ReturnType = {
  /** クライアントデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsClientsClientId200;
};

type IUseGetClient = (args: Args) => ReturnType;

/**
 * 利用企業編集フォーム用クライアント詳細取得フック（新版）
 *
 * @param threeLetterCode - パートナーを識別する3文字コード
 * @param clientId - クライアントID（数値）
 */
export const useGetClient: IUseGetClient = ({ threeLetterCode, clientId }) => {
  const clientIdStr = String(clientId);
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsClientsClientIdKey(threeLetterCode, clientIdStr),
    () => getApiV1ThreeLetterCodePartnerAdminsClientsClientId(threeLetterCode, clientIdStr),
    { suspense: true }
  );

  return { data };
};
